import { MapViewerService } from '@3ddv/ngx-dvm-internal';
import { InjectionToken } from '@angular/core';

/**
 * A second, independent `MapViewerService` instance dedicated to the minimap —
 * distinct from the main viewer's instance (`inject(MapViewerService)` in DvmService).
 * `<dvm-map-viewer [service]="dvmService.minimapService">` (viewer.component.html)
 * expects this to already hold a valid instance by the time it's first rendered —
 * it no longer exposes its own internally-created instance back to the parent
 * (`service` is an input-only signal as of @3ddv/ngx-dvm-internal 5.x), so DvmService
 * must own and inject it up front rather than reading it out of the child afterward.
 */
export const MINIMAP_TOKEN = new InjectionToken<MapViewerService>(
  'MINIMAP_TOKEN'
);
